// NOTE: this file is concatenated + uglified with the rest of the theme's JS,
// so it must stay ES5-safe. WebGL mode is loaded via a dynamically-injected
// <script type="module"> tag rather than dynamic import(), which legacy
// uglify-js cannot parse.
(function () {
    var heroSection = document.querySelector('.hero');
    if (!heroSection) {
        return;
    }

    var mode = heroSection.getAttribute('data-hero-mode') || 'WebGL';
    var canvas = heroSection.querySelector('.hero-canvas');
    var poster = heroSection.querySelector('.hero-poster');
    var video = heroSection.querySelector('.hero-showreel');

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isSmall = window.innerWidth < 768;
    var hasWebGL = (function () {
        try {
            var c = document.createElement('canvas');
            return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl') || c.getContext('experimental-webgl')));
        } catch (e) {
            return false;
        }
    }());
    var lowMemory = !!(navigator.deviceMemory && navigator.deviceMemory < 4);

    function showPoster() {
        if (poster) { poster.hidden = false; }
        if (canvas) { canvas.hidden = true; }
        if (video) { video.hidden = true; }
    }

    function showShowreel() {
        if (!video || !video.querySelector('source')) {
            showPoster();
            return;
        }
        if (poster) { poster.hidden = true; }
        if (canvas) { canvas.hidden = true; }
        video.hidden = false;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
        }
    }

    function showWebGL() {
        if (!canvas || reducedMotion || isSmall || !hasWebGL || lowMemory) {
            showPoster();
            return;
        }
        if (poster) { poster.hidden = true; }
        if (video) { video.hidden = true; }
        canvas.hidden = false;

        var script = document.createElement('script');
        script.type = 'module';
        script.src = canvas.getAttribute('data-module');
        script.onerror = showPoster;
        document.body.appendChild(script);
    }

    if (reducedMotion) {
        showPoster();
    } else if (mode === 'Showreel') {
        showShowreel();
    } else if (mode === 'Static') {
        showPoster();
    } else {
        showWebGL();
    }

    var scrollCue = heroSection.querySelector('.hero-scroll-cue');
    if (scrollCue) {
        scrollCue.addEventListener('click', function (e) {
            var target = document.querySelector(scrollCue.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
            }
        });
    }
}());
